const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_78",
    "data-name": "Grupo 78",
    transform: "translate(-594 -4166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_55",
    d: "M19.334 1H2.667A1.672 1.672 0 001 2.667v16.667A1.672 1.672 0 002.667 21h16.667A1.672 1.672 0 0021 19.334V2.667A1.672 1.672 0 0019.334 1z",
    "data-name": "Trazado 55",
    transform: "translate(593 4165)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__iconfinder_youtube_317714",
    transform: "translate(594.799 4165.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_53",
    d: "M18.059 6.953a4.386 4.386 0 00-.725-1.933 2.517 2.517 0 00-1.827-.82C12.954 4 9.125 4 9.125 4h-.009s-3.829 0-6.381.2a2.517 2.517 0 00-1.828.823 4.394 4.394 0 00-.725 1.93A31.344 31.344 0 000 10.1v1.476a31.333 31.333 0 00.182 3.149 4.377 4.377 0 00.725 1.931 2.983 2.983 0 002.011.832c1.459.149 6.2.2 6.2.2s3.833-.007 6.386-.2a2.527 2.527 0 001.828-.825 4.385 4.385 0 00.725-1.931 31.348 31.348 0 00.182-3.149V10.1a31.348 31.348 0 00-.18-3.147z",
    "data-name": "Trazado 53",
    style: {
      fill: "#77777c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_54",
    d: "M12 10v6.843l5.7-3.421z",
    "data-name": "Trazado 54",
    transform: "translate(-5.157 -2.579)",
    style: {
      fill: "#f5f5f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.acfd679fc29f194b6bcc026b03e8ee27.svg";
export { ForwardRef as ReactComponent };